<template>
<div class="form-group form-group--group">
  <div class="row">
    <div :class="`col-sm-${component.size}`">
      <div class="panel panel-default">
        <div class="panel-heading" v-if="!component.hideLabel || component.description">
          <h4 class="panel-title" v-if="!component.hideLabel">{{ component.label }}</h4>
          <span class="panel-description" v-if="component.description" v-html="component.description"></span>
        </div>
        <div class="panel-body">
          <component v-for="(children, index) in component.components"
                     :is="`${children.type}-field`"
                     :component="children"
                     :key="children.key"
                     :index="index"
                     v-show="!$checkConditionalViewAllow(children, components, variables, json)" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

// Components
import TextField from '@/components/text/TextField.vue'
import PasswordField from '@/components/password/PasswordField.vue'
import NumberField from '@/components/number/NumberField.vue'
import SelectField from '@/components/select/SelectField.vue'
import SelectApiField from '@/components/select-api/SelectApiField.vue'
import SelectResourceField from '@/components/select-resource/SelectResourceField.vue'
import TextareaField from '@/components/textarea/TextAreaField.vue'
import CheckboxSingleField from '@/components/checkbox-single/CheckboxSingleField.vue'
import CheckboxField from '@/components/checkbox/CheckboxField.vue'
import RadioField from '@/components/radio/RadioField.vue'
import FileField from '@/components/file/FileField.vue'
import DatepickerField from '@/components/datepicker/DatepickerField.vue'
import HelpBlockField from '@/components/help-block/HelpBlockField.vue'

export default {
  props: ['component'],
  inject: ['$validator'],
  name: 'component-group',
  components: {
    TextField,
    PasswordField,
    NumberField,
    SelectField,
    SelectApiField,
    SelectResourceField,
    TextareaField,
    CheckboxSingleField,
    CheckboxField,
    RadioField,
    FileField,
    DatepickerField,
    HelpBlockField
  },
  computed: {
    ...mapState({
      components: state => state.formJson.components,
      variables: state => state.config.variables,
      json: state => state.config.json
    })
  }
}
</script>
